import React, { useState, useEffect, useRef } from "react"; 
import { visa_image, credit_card, visa_image2, visa_image3, visa_image4, check_image } from "../../assets/images/images"
//import { payment_card  } from "../../../../../../assets/images/images";
import { loadStripe } from '@stripe/stripe-js';
import { removeCartData, resetRemoveCart } from '../../state/actions/removeCartAction';
import { Elements, CardNumberElement, CardExpiryElement, CardCvcElement, cardholderName, useStripe, useElements } from '@stripe/react-stripe-js';
import './StripePayment.css'; // Make sure to create a CSS file for styles
import BackButton from '../BackButton/BackButton';
import SuccessModal from "./OrderSucess";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from '../../features/auth/AuthContext';
import api from '../../api/api';
import { proceedToPayData, resetProceedToPay } from '../../state/actions/coursePaymentAction';
// import { useLocation, useNavigate } from "react-router";
// import { useNavigate } from "react-router";
import { createMeetingBooking } from '../../components/BookAMeeting/meetingService';
import { useNavigate, useLocation } from "react-router";
import { toast } from 'react-toastify';
import { Modal } from "react-responsive-modal";
import CancelPopup from '../CancelPopup/CancelPopup';
import {
  cartList,
  resetCartList 
} from "../../state/actions/cartlistAction";
import LoaderComponent from "../LoaderComponent/LoaderComponent";
import CongratulationsPopup from "../CongratulationsPopup/CongratulationsPopup.jsx";
import {
  down_arrow,
  image1,
  logout_image,
  notification,
  profile_image,
  Proschool_LOGO_1,
  Proschool_logo_svg,
  Regenerate_course_image,
} from "../../assets/images/images";
import { Ring } from "@uiball/loaders";


function CheckoutForm({ purchaseType: propPurchaseType = "course", bookingData: propBookingData = null, teacherOptions: propTeacherOptions = null }) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const location = useLocation();

  // Try to get from props first, fallback to location.state for backwards compatibility
  const locationState = location.state || {};
  const purchaseType = propPurchaseType || locationState.purchaseType || "course";
  const bookingData = propBookingData || locationState.bookingData || null;

  const teacherOptions = propTeacherOptions || locationState.teacherOptions || null;
  const [error, setError] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState('');
  const [paymentSuccessPopup, setpaymentSuccessPopup] = useState(false);
  const [cardholderName, setCardholderName] = useState(''); // State to hold the cardholder's name
  const [isCardNumberValid, setCardNumberValid] = useState(false);
  const [isCardExpiryValid, setCardExpiryValid] = useState(false);
  const [isCardCvcValid, setCardCvcValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isPaymentLoading, setisPaymentLoading] = useState(false);
  const [item_id, setitem_id] = useState();
  const formRef = useRef(null); // Ref for the form
  const { token } = useAuth();
  const dispatch = useDispatch();
  const removeCart = useSelector((state) => state.removeCartData);
  const [isTransactionFail, setIsTransactionFail] = useState(false);

  // ─── NEW validation state ───────────────────────────────────────────────
const [touched, setTouched] = useState({
  cardNumber: false,
  cardExpiry: false,
  cardCvc: false,
  cardholderName: false,
});

const [stripeErrors, setStripeErrors] = useState({
  cardNumber: '',
  cardExpiry: '',
  cardCvc: '',
});

// ─── Cardholder name validation ─────────────────────────────────────────
const validateCardholderName = (name) => {
  if (!name.trim()) return 'Name on card is required.';
  if (!/^[a-zA-Z\s'-]+$/.test(name)) return 'Name may only contain letters, spaces, hyphens, or apostrophes.';
  if (name.trim().length < 2) return 'Name must be at least 2 characters.';
  if (name.trim().length > 50) return 'Name must be 50 characters or fewer.';
  return '';
};

const cardholderNameError = touched.cardholderName ? validateCardholderName(cardholderName) : '';




  const proceedToPay = useSelector((state) => state?.proceedToPay);

  const proceedToPaybtn = () => {
    setisPaymentLoading(true)

    // For meet_session: booking already created in BookingModal, just proceed to payment
    // For course: need to create order first
    if (purchaseType === "meet_session") {
      // Booking already created, go directly to payment
      handleSubmit();
    } else {
      // Course purchase: create order first
      dispatch(proceedToPayData(token, null, false, 0, purchaseType, null));
    }
  };


  const paymenPricedata = useSelector((state) => state?.cartlist);

const getCurrencySymbol = () => {
    // For meet_session, get currency from teacher options
    if (purchaseType === "meet_session") {
        return teacherOptions?.currency_symbol || "$";
    }
    // For course purchases, default to dollar
    return "$";
};
const calculateTotalPrice = () => {
    // For meet_session (booking), price comes from route state or proceedToPay
    if (purchaseType === "meet_session") {
        const price = locationState.amount || proceedToPay?.booking_data?.payment?.amount;
        if (price) return String(price);
    }

    // For course purchases, calculate from cartlist
    if (!paymenPricedata?.cartList || !Array.isArray(paymenPricedata.cartList)) return "0.00";

    let totalPrice = 0;
    paymenPricedata.cartList.forEach(item => {
        const price = item?.discounted_price != null
            ? parseFloat(item.discounted_price)
            : parseFloat(item?.price);
        totalPrice += isNaN(price) ? 0 : price;
    });
    return totalPrice.toFixed(2);
}

  // Function to dynamically adjust CARD_ELEMENT_OPTIONS based on screen width
  const getCardElementOptions = () => {
    // Default fontSize
    let fontSize = '16px';

    // Check if the screen width is less than or equal to 600px (common breakpoint for mobile devices)
    // if (window.innerWidth <= 600) {
    //   // Adjust fontSize for mobile screens
    //   fontSize = '12px';
    // }
    if (window.innerWidth <= 768) {
      // Adjust fontSize for mobile screens
      fontSize = '12px';
    }

    // Return the CARD_ELEMENT_OPTIONS with the adjusted fontSize
    return {
      style: {
        base: {
          fontSize: fontSize,
          color: '#424770', // Text color
          '::placeholder': {
            color: '#808080', // Placeholder text color
          },
        },
        invalid: {
          color: '#9e2146', // Color for invalid input
        },
      },
    };
  };

  // Use this function to get the dynamically adjusted options
  const CARD_ELEMENT_OPTIONS = getCardElementOptions();


  const [fontSize, setFontSize] = useState('14px'); // Default to mobile view

  useEffect(() => {
    const updateFontSize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth > 1024) {
        setFontSize('16px'); // Desktop
      } else if (screenWidth > 768) {
        setFontSize('15px'); // Tablet
      } else {
        setFontSize('14px'); // Mobile
      }
    };

    window.addEventListener('resize', updateFontSize);
    updateFontSize(); // Initialize font size

    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  const handleSubmit = async () => {
    //event.preventDefault();

    if (!stripe || !elements) {
      setError('Stripe has not loaded yet.');
      toast.error('Stripe has not loaded yet.')
      setIsTransactionFail(true);
      return;
    }

    try {
      const cardElement = elements.getElement(CardNumberElement);

      // For meet_session, use orderId from route state (set at navigation time)
      // For courses, use Redux proceedToPay.order_id
      const orderId = purchaseType === "meet_session"
        ? locationState.orderId
        : proceedToPay?.order_id;

      if (!orderId) {
        toast.error("Order not found. Please go back and book again.");
        setisPaymentLoading(false);
        return;
      }

      const payload = {
        order_id: orderId,
        purchase_type: purchaseType,
        payment_gateway: "stripe",
      };
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }
      };

      const paymentIntentResponse = await api.post('payments/payment/', payload, config);
      const clientSecret = paymentIntentResponse.data.client_secret

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: cardholderName,
          },
        },
      });


      if (result.error) {
        
        setError(result.error.message);
        setIsTransactionFail(true);
        setisPaymentLoading(false)
        toast.error('Payment failed. Please try again.');
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          setIsTransactionFail(false);
          setisPaymentLoading(false)
          setPaymentStatus('Payment succeeded!');
          setpaymentSuccessPopup(true);
        }
      }
    } catch (err) {
      setError('An error occurred.');
      setisPaymentLoading(false)
        const errorMessage = err?.response?.data?.message   // backend error message
    || err?.response?.data?.error                      // alternate backend field
    || err?.message                                    // AxiosError message
    || 'An error occurred.';
  
  toast.error(errorMessage, {
    position: "top-center",
  });
    }
  };

  useEffect(() => {
    // Only auto-submit for course purchases, not for meet_session bookings
    // For meet_session, user must manually click "Proceed to Pay" after filling card details
    if (proceedToPay.order_id != null && purchaseType !== "meet_session") {
      handleSubmit();
    }

  }, [proceedToPay.order_id, purchaseType])



  useEffect(() => {
  if (paymentSuccessPopup) {
    setTimeout(() => {
      setpaymentSuccessPopup(false);

      // Only refresh cart for course purchases, not for meet_session bookings
      if (purchaseType !== "meet_session") {
        dispatch(resetRemoveCart());
        dispatch(resetCartList());
      }

      // Redirect based on purchase type
      const redirectUrl = purchaseType === "meet_session"
        ? `/dashboard/meetings`
        : `/dashboard/my-courses/active-courses`;
      navigate(redirectUrl);
    }, 5000);
  }
}, [paymentSuccessPopup, purchaseType, dispatch, navigate]); 

  useEffect(() => {
    if (removeCart?.message?.length) {
      toast.success(removeCart?.message);
    }
    if (removeCart?.error?.length) {
      toast.error(removeCart?.error)
    }
    return () => {
      dispatch(resetRemoveCart());
    }
  }, [removeCart]);

  // Trigger form submission from the "Proceed to Pay" button
  const handleClick = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  };




  // };

  //new
  const handleChange = (event) => {
  // Mark field as touched on first interaction
  setTouched((prev) => ({ ...prev, [event.elementType === 'cardNumber' ? 'cardNumber' : event.elementType === 'cardExpiry' ? 'cardExpiry' : 'cardCvc']: true }));

  const fieldMap = {
    cardNumber: 'cardNumber',
    cardExpiry: 'cardExpiry',
    cardCvc: 'cardCvc',
  };
  const key = fieldMap[event.elementType];

  if (key) {
    // Stripe gives us an error object when input is invalid
    setStripeErrors((prev) => ({
      ...prev,
      [key]: event.error ? event.error.message : '',
    }));

    switch (event.elementType) {
      case 'cardNumber': setCardNumberValid(event.complete); break;
      case 'cardExpiry': setCardExpiryValid(event.complete); break;
      case 'cardCvc':    setCardCvcValid(event.complete);    break;
      default: break;
    }
  }
};


  //new
  const isFormValid = () => {
  // For bookings: check card details and that we have booking data
  if (purchaseType === "meet_session") {
    return (
      isCardNumberValid &&
      isCardExpiryValid &&
      isCardCvcValid &&
      validateCardholderName(cardholderName) === '' &&
      bookingData !== null
    );
  }

  // For course purchases: check cart items
  return (
    isCardNumberValid &&
    isCardExpiryValid &&
    isCardCvcValid &&
    validateCardholderName(cardholderName) === '' &&
    (paymenPricedata?.cartList?.length ?? 0) > 0
  );
};
  const show = () => {
    setOpenDialog(false)

    const req = {
      cart_item_id: item_id
    };
    dispatch(removeCartData(req, token));
  };

  const close = (id) => {
    setitem_id(id)
    setOpenDialog(!openDialog); // This will close the popup
  };

  const handleClosePopup = () => {
    setpaymentSuccessPopup(false);
  };

  const handleRetry = () => {    
  setIsTransactionFail(false);
  setError(null);
  setisPaymentLoading(false);
};

useEffect(() => {
  return () => {
    // Cleanup on unmount (including back navigation)
    dispatch(resetProceedToPay());
    setIsTransactionFail(false);
    setError(null);
    setisPaymentLoading(false);
  };
}, []);


  return (
    <div className='paymentStripe-section'>
      <BackButton buttonName="Back" style={{ width: "30%" }} />
      <div className='paymentStripe-wrapper'>
        <div className='paymentStrip-left-section'>
          <div className='payment-des-container'>
            <p>Safe money transfer using  your bank account.
              Visa, Mastercard, Discover, and American express.
            </p>
            <div className='payment-visa-image-folder'>
              <div className='payment-visa-image'>
                <img src={visa_image} />
              </div>
              <div className='payment-visa-image'>
                <img src={visa_image2} />
              </div>
              <div className='payment-visa-image'>
                <img src={visa_image3} />
              </div>
              <div className='payment-visa-image'>
                <img src={visa_image4} />
              </div>
            </div>

          </div>
<form className='payment-form'>

  {/* Card Number */}
  <div className="payment-form-input">
    <label htmlFor="cardNumber">Card Number</label>
    <div className="input-field-wrapper">
      <div className={`stripe-element-wrapper ${touched.cardNumber && stripeErrors.cardNumber ? 'input-error' : touched.cardNumber && isCardNumberValid ? 'input-valid' : ''}`}>
        <CardNumberElement id="cardNumber" options={CARD_ELEMENT_OPTIONS} onChange={handleChange} onBlur={() => setTouched((prev) => ({ ...prev, cardNumber: true }))} />
      </div>
      <img className="credit_card" src={credit_card} />
    </div>
    {touched.cardNumber && stripeErrors.cardNumber && (
      <span className="field-error">{stripeErrors.cardNumber}</span>
    )}
  </div>

  {/* Expiry + CVC */}
  <div className='payment-form-Card-inner-wrapper'>
    <div className="payment-form-input">
      <label htmlFor="cardExpiry">Card Expiry</label>
      <div className="input-field-wrapper">
        <div className={`stripe-element-wrapper ${touched.cardExpiry && stripeErrors.cardExpiry ? 'input-error' : touched.cardExpiry && isCardExpiryValid ? 'input-valid' : ''}`}>
          <CardExpiryElement id="cardExpiry" options={CARD_ELEMENT_OPTIONS} onChange={handleChange} onBlur={() => setTouched((prev) => ({ ...prev, cardExpiry: true }))} />
        </div>
        <img className="credit_card" src={credit_card} />
      </div>
      {touched.cardExpiry && stripeErrors.cardExpiry && (
        <span className="field-error">{stripeErrors.cardExpiry}</span>
      )}
    </div>

    <div className="payment-form-input">
      <label htmlFor="cardCvc">CVC</label>
      <div className="input-field-wrapper">
        <div className={`stripe-element-wrapper ${touched.cardCvc && stripeErrors.cardCvc ? 'input-error' : touched.cardCvc && isCardCvcValid ? 'input-valid' : ''}`}>
          <CardCvcElement id="cardCvc" options={CARD_ELEMENT_OPTIONS} onChange={handleChange} onBlur={() => setTouched((prev) => ({ ...prev, cardCvc: true }))} />
        </div>
        <img className="credit_card" src={credit_card} />
      </div>
      {touched.cardCvc && stripeErrors.cardCvc && (
        <span className="field-error">{stripeErrors.cardCvc}</span>
      )}
    </div>
  </div>

  {/* Name on Card */}
  <div className="payment-form-input">
    <label htmlFor="cardholder-name">Name on Card</label>
    <div className="input-field-wrapper">
      <input
        id="cardholder-name"
        type="text"
        placeholder="Enter your name"
        required
        value={cardholderName}
        maxLength={50}
        className={touched.cardholderName && cardholderNameError ? 'input-error' : touched.cardholderName && !cardholderNameError && cardholderName.trim() ? 'input-valid' : ''}
        onChange={(e) => {
          setCardholderName(e.target.value);
          if (!touched.cardholderName) setTouched((prev) => ({ ...prev, cardholderName: true }));
        }}
        onBlur={() => setTouched((prev) => ({ ...prev, cardholderName: true }))}
      />
      <img className="credit_card" src={credit_card} />
    </div>
    {touched.cardholderName && cardholderNameError && (
      <span className="field-error">{cardholderNameError}</span>
    )}
  </div>

</form>
        </div>
        <div className='paymentStrip-right-section'>
          <h2>Billing Summary</h2>
          <div className="paymentStripe-course-container">
            {purchaseType === "meet_session" ? (
              <div className="paymentStripe-course-folder">
                <div className="paymentStripe-course">
                  <span>1-on-1 Meeting Session</span>
                  <span>{bookingData?.sessionSlot || "30 minutes"}</span>
                </div>
              </div>
            ) : (
              <>
            {(() => {
  const count = paymenPricedata?.cartList?.filter((item) => item?.price !== null)?.length || 0;
  return <p>{count === 1 ? 'Course' : 'Courses'} <span>({count})</span></p>;
})()}
            <div className="paymentStripe-course-folder">
              {paymenPricedata?.cartList?.length === 0 ? <p className="paymentStripe-course-no-courses-found">No Courses Found</p> : paymenPricedata?.cartList?.filter((items) => items?.price !== null).map((items, index) => (
                <div key={index} className="paymentStripe-course">
                  <span>{items.name}</span>
                  <span><span onClick={() => close(items.cart_item_id)}><i class="fa-solid fa-x"></i></span> ${items.discounted_price === null ? items.price : items.discounted_price}</span>
                </div>
              ))}
            </div>
              </>
            )}
          </div>
          {/* <p>Course: <span>Fundamental of Neuroscience</span></p> */}
          <div className='paymentStrip-price-wrapper'>
            <div className='paymentStrip-price-folder'>
              <span>Price</span>
              <span>{getCurrencySymbol()}{calculateTotalPrice()}</span>
            </div>
            <div className='paymentStrip-price-totle-folder'>
              <span>Total</span>
              <span>{getCurrencySymbol()}{calculateTotalPrice()}</span>
            </div>
          </div>
          {/* <button className='promo-code-btn'>Have a Promo code?</button> */}
          <button
            className='payment-proceed-to-pay'
            onClick={proceedToPaybtn}
            disabled={!isFormValid() || isPaymentLoading}
            style={{
              backgroundColor: isFormValid() ? '#0068FF' : 'gray', // Change 'normalBackgroundColor' to your desired color
              color: isFormValid() ? '#ffffff' : 'colorWhenDisabled', // Optionally set the text color
            }}
          >
            {isPaymentLoading ? <Ring size={20} lineWeight={5} speed={2} color="white" /> :
              "Proceed to Pay"
            }
          </button>

        </div>
        <div className='paymentStripe-section'>
        </div>
      </div>




      {/* NEW COngratulations */}

      {
         paymentSuccessPopup &&
        <div className="popup-overlay">
          <div className="popup-containerB">
            <button className="popup-close" onClick={() => setpaymentSuccessPopup(false)}>
          ✕
        </button>

            <div className="success-animation">
              <div className="checkmark-circle">
                <div className="checkmark draw"></div>
              </div>
            </div>

            <h2 className="popup-title">Congratulations!</h2>

            {/* <p className="popup-message">
          You have successfully purchased{" "}
          <span className="course-name">“Harappa Civilization”</span> Course
        </p> */}
            <p className="popup-message">
              {purchaseType === "meet_session" ? (
                "Your meeting has been successfully booked!"
              ) : (
                <>
              You have successfully purchased{" "}
              <span className="course-name">
                {paymenPricedata?.cartList?.map((item, index) => (
                  <span key={index}>
                    {item.name}
                    {index !== paymenPricedata.cartList.length - 1 && ", "}
                  </span>
                ))}
              </span>
              {paymenPricedata?.cartList?.length > 1 ? " Courses" : " Course"}
                </>
              )}
            </p>

            <div className="popup-support">
              <p>Need Help?</p>
              <p>
                For assistance, please visit{" "}
                <a href="/SupportRequest?from=mycourse" target="blank" className="support-link" >
                  our support page
                </a>.
              </p>
            </div>
          </div>
        </div>
      }


      {/* NEW TRANSACTION FAILED */}


      { 
      isTransactionFail &&
         <div>
          <div className="fp-overlay">
            <div className="fp-container">

              <button className="fp-close-btn" style={{
          position: "absolute",
          top: "12px",
          right: "12px",
          background: "none",
          border: "none",
          fontSize: "18px",
          cursor: "pointer",
          color: "#e11818",
        }} onClick={handleRetry}>✕</button>
              <div className="fp-icon-wrap" aria-hidden="true">
                <div className="fp-icon-circle">
                  <span className="fp-icon-mark">!</span>
                </div>
              </div>

              <h2 className="fp-title">Transaction Failed!</h2>

              <p className="fp-message">
                {purchaseType === "meet_session" ? (
                  "We couldn't complete your payment for the meeting booking."
                ) : (
                  <>
                We couldn&apos;t complete your payment for{" "}
              <span className="fp-course">
                {paymenPricedata?.cartList?.map((item, index) => (
                  <span key={index}>
                    {item.name}
                    {index !== paymenPricedata.cartList.length - 1 && ", "}
                  </span>
                ))}
              </span>
              {paymenPricedata?.cartList?.length > 1 ? " Courses" : " Course"}
                  </>
                )}
              </p>

              <div className="fp-support">
                <p className="fp-support-title">Need Help?</p>
                <p className="fp-support-text">
                  For assistance, please visit{" "}
                  <a className="fp-link" href="/SupportRequest" target="blank">
                    our support page
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      }

      {/* Transaction pending */}
      {
        isPaymentLoading && <div>
          <div className="pp-overlay">
            <div className="pp-container">


              {/* Icon */}
              <div className="pp-icon" aria-hidden="true">
                <div className="pp-doc">
                  <span className="pp-line l1" />
                  <span className="pp-line l2" />
                  <span className="pp-line l3" />

                  <span className="pp-check c1" />
                  <span className="pp-check c2" />
                </div>

                <div className="pp-card">
                  <span className="pp-card-strip" />
                  <span className="pp-card-chip" />
                </div>
              </div>

              <h2 className="pp-title">Please Wait</h2>

              <p className="pp-sub">
                Completing your transaction<span className="pp-dots" />
              </p>
            </div>
          </div>
        </div>
      }


      {openDialog && (
        <Modal
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          center
          showCloseIcon={false}
          classNames={{
            modal: 'Cancel-Popup',
          }}
        >
          <CancelPopup
            title="Are you sure you want to remove this course from the cart?"
            No="No"
            Yes="Yes"
            show={show} // Assuming you have a state or value to pass 
            close={close} // Pass the reference, not the invocation
          />
        </Modal>
      )}
    </div>
  );
}

function StripePaymentForm({ purchaseType = "course", bookingData = null }) {

  const globalState = useSelector((state) => state.globalState);
  console.warn("globalState?.student_details?.data?.is_test", globalState?.student_details?.data?.is_test)

  const stripePromise = loadStripe(globalState?.student_details?.data?.is_test ? process.env.REACT_APP_TEST_PUBLISH_KEY : process.env.REACT_APP_PUBLISH_KEY); // Replace with your Stripe publishable key




  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm purchaseType={purchaseType} bookingData={bookingData} />
    </Elements>
  );
}


export default StripePaymentForm;